// useProximity.js
import { useState } from 'react';

export const useProximity = (orders) => {
    const [sortedOrders, setSortedOrders] = useState(orders);
    const [isLocating, setIsLocating] = useState(false);

    // Haversine Formula to calculate distance in KM
    const calculateDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371;
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLon = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    };

    const sortByNearest = () => {
        setIsLocating(true);
        if (!navigator.geolocation) {
            alert("Geolocation not supported");
            setIsLocating(false);
            return;
        }

        navigator.geolocation.getCurrentPosition((position) => {
            const userLat = position.coords.latitude;
            const userLon = position.coords.longitude;

            const updated = orders.map(order => {
                // Assume your order has 'lat' and 'lng' from the geocoding process
                const dist = order.lat ? calculateDistance(userLat, userLon, order.lat, order.lng) : 9999;
                return { ...order, distance: dist };
            }).sort((a, b) => a.distance - b.distance);

            setSortedOrders(updated);
            setIsLocating(false);
        }, () => {
            alert("Please enable GPS/Location");
            setIsLocating(false);
        });
    };

    return { sortedOrders, isLocating, sortByNearest };
};